import * as i0 from '@angular/core';
import { TemplateRef, Directive, Input, NgModule } from '@angular/core';

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzStringTemplateOutletDirective = /*#__PURE__*/(() => {
  class NzStringTemplateOutletDirective {
    static ngTemplateContextGuard(_dir, _ctx) {
      return true;
    }
    recreateView() {
      this.viewContainer.clear();
      const isTemplateRef = this.nzStringTemplateOutlet instanceof TemplateRef;
      const templateRef = isTemplateRef ? this.nzStringTemplateOutlet : this.templateRef;
      this.embeddedViewRef = this.viewContainer.createEmbeddedView(templateRef, isTemplateRef ? this.nzStringTemplateOutletContext : this.context);
    }
    updateContext() {
      const isTemplateRef = this.nzStringTemplateOutlet instanceof TemplateRef;
      const newCtx = isTemplateRef ? this.nzStringTemplateOutletContext : this.context;
      const oldCtx = this.embeddedViewRef.context;
      if (newCtx) {
        for (const propName of Object.keys(newCtx)) {
          oldCtx[propName] = newCtx[propName];
        }
      }
    }
    constructor(viewContainer, templateRef) {
      this.viewContainer = viewContainer;
      this.templateRef = templateRef;
      this.embeddedViewRef = null;
      this.context = new NzStringTemplateOutletContext();
      this.nzStringTemplateOutletContext = null;
      this.nzStringTemplateOutlet = null;
    }
    ngOnChanges(changes) {
      const {
        nzStringTemplateOutletContext,
        nzStringTemplateOutlet
      } = changes;
      const shouldRecreateView = () => {
        let shouldOutletRecreate = false;
        if (nzStringTemplateOutlet) {
          if (nzStringTemplateOutlet.firstChange) {
            shouldOutletRecreate = true;
          } else {
            const isPreviousOutletTemplate = nzStringTemplateOutlet.previousValue instanceof TemplateRef;
            const isCurrentOutletTemplate = nzStringTemplateOutlet.currentValue instanceof TemplateRef;
            shouldOutletRecreate = isPreviousOutletTemplate || isCurrentOutletTemplate;
          }
        }
        const hasContextShapeChanged = ctxChange => {
          const prevCtxKeys = Object.keys(ctxChange.previousValue || {});
          const currCtxKeys = Object.keys(ctxChange.currentValue || {});
          if (prevCtxKeys.length === currCtxKeys.length) {
            for (const propName of currCtxKeys) {
              if (prevCtxKeys.indexOf(propName) === -1) {
                return true;
              }
            }
            return false;
          } else {
            return true;
          }
        };
        const shouldContextRecreate = nzStringTemplateOutletContext && hasContextShapeChanged(nzStringTemplateOutletContext);
        return shouldContextRecreate || shouldOutletRecreate;
      };
      if (nzStringTemplateOutlet) {
        this.context.$implicit = nzStringTemplateOutlet.currentValue;
      }
      const recreateView = shouldRecreateView();
      if (recreateView) {
        /** recreate view when context shape or outlet change **/
        this.recreateView();
      } else {
        /** update context **/
        this.updateContext();
      }
    }
    static {
      this.ɵfac = function NzStringTemplateOutletDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzStringTemplateOutletDirective)(i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(i0.TemplateRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NzStringTemplateOutletDirective,
        selectors: [["", "nzStringTemplateOutlet", ""]],
        inputs: {
          nzStringTemplateOutletContext: "nzStringTemplateOutletContext",
          nzStringTemplateOutlet: "nzStringTemplateOutlet"
        },
        exportAs: ["nzStringTemplateOutlet"],
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature]
      });
    }
  }
  return NzStringTemplateOutletDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class NzStringTemplateOutletContext {}

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */
let NzOutletModule = /*#__PURE__*/(() => {
  class NzOutletModule {
    static {
      this.ɵfac = function NzOutletModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NzOutletModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: NzOutletModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return NzOutletModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NzOutletModule, NzStringTemplateOutletDirective };
